import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { useIsAdmin } from "../hooks/useIsAdmin";
import { PageLoader } from "./ui";

export function PrivateRoute() {
  const { currentUser } = useAuth();
  const location = useLocation();
  if (!currentUser) return <Navigate to="/login" replace state={{ from: location }} />;
  return <Outlet />;
}

// Login y registro: si ya hay sesión, vuelve a donde quería ir el usuario.
export function PublicOnlyRoute() {
  const { currentUser } = useAuth();
  const location = useLocation();
  if (currentUser) return <Navigate to={location.state?.from?.pathname || "/dashboard"} replace />;
  return <Outlet />;
}

// Solo administradores (custom claim admin: true). Igual el servidor revisa el claim en cada acción.
export function AdminRoute() {
  const { loading, isAdmin } = useIsAdmin();
  if (loading) return <PageLoader />;
  if (!isAdmin) return <Navigate to="/dashboard" replace />;
  return <Outlet />;
}
